import { CFIconOptions } from './options';
import { CFIconOptions2 } from './options-2';
import { CFIconRadioButtonOff } from './radio-button-off';
import { CFIconRadioButtonOn } from './radio-button-on';
import { CFIconToggleLeft } from './toggle-left';
import { CFIconToggleRight } from './toggle-right';
export const CFIconGroupControls = [
    CFIconOptions,
    CFIconOptions2,
    CFIconRadioButtonOff,
    CFIconRadioButtonOn,
    CFIconToggleLeft,
    CFIconToggleRight,
];
